import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SideNav } from "../shared-components/side-nav";
import { Accordion, Card, Tabs } from "@veneer/core";
import {
  useNavigate,
  useSearchParams,
  useLocation,
  Navigate,
} from "react-router-dom";
import { deepParse } from "./customer-availability/edit-customer-availability";
import CaseInformationSummary from "./case-information-summary/case-information-summary";
import CaseHistory from "./case-history/case-history";
import CaseItems from "@components/home-page/shared-components/case-items/case-items";
import CaseDetails from "./case-details/case-details";
import PartService from "./part-service/part-service";
import LocationInfo from "./location-info/location-info";
import UpdateCase from "./update-case/update-case";
import CloseCase from "./close-case/close-case";
import MoreSupportOptions from "./more-support-options/more-support-options";
import {
  editCaseDetails,
  AttachedFileState,
} from "../../../services/typedefine";
import { apiGet, apiPost } from "../../../services/service";
import {
  POST_UPDATE_CASE,
  POST_CLOSE_CASE,
  POST_PAGE_LOAD_EDIT_CASE,
  POST_PRODUCT_INFO_EDIT_CASE,
  POST_UPDATE_CUSTOMER_AVAILABILITY,
} from "../../../services";
import { Trans, useTranslation } from "react-i18next";
import Loader from "../shared-components/loader/loader";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { setLoading } from "@store/reducers/loadingSlice";

import "./edit-case.scss";
import { toast } from "react-toastify";
import { validateAddress } from "utils";
import CaseEmailInteraction from "./case-email-interaction/case-email-interaction";
import { handleErrorResponse } from "utils";
// import { FeedBackModal } from "./feedback-modal/feedback-modal";
import { OnSubmitModal } from "./submitpopups-modal/submitpopup-modal";
import EditCustomerAvailability from "./customer-availability/edit-customer-availability";
export const EditCase = () => {
  const [activeAccordian, setActiveAccordian] = useState(3);
  const [productInfo, setProductInfo] = useState<any>([]);
  const [polyProductInfo, setPolyProductInfo] = useState<any>([]);
  const [editCaseDetails, setEditCaseDetails] =useState<editCaseDetails>();
  const [customerAvailabilityOptions, setCustomerAvailabilityOptions] =useState<any>(null);
  // const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false);
  const [showOnSubmitModal, setShowOnSubmitModal] = useState<boolean>(false);
  const [allEmailInteractions, setAllEmailInteractions] = useState<[] | null>(null);
  const [accordionItems, setAccordionItems] = useState<any[]>([]);
  const [attachedFile, setAttachedFile] = useState<AttachedFileState>();
  const [isActiveCareProduct, setIsActiveCareProduct] = useState<boolean>(false);
  const [isTeradeciCall, setIsTeradeciCall] = useState<boolean>(false);
  const [tempAttachedFilesData, setTempAttachedFilesData] = useState<any>([])
  const[caseExtensionId,setCaseExtenasionId] = useState<any>()

  const [accordionMoreSupportItems, setAccordionMoreSupportItems] = useState<any[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [reload, setReload] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const caseNumberId = location.state?.data?.incidentid || searchParams.get("cid");

  useEffect(() => {
    return () => {
      setTempAttachedFilesData([]);
    };
  }, []);

  useEffect(() => {
    const pageLoadFetch = async () => {
      dispatch(setLoading(true));
      const data = location.state?.data;

      const payload = {
        caseId: data?.incidentid || searchParams.get("cid"),
        userId: "f16eeb64-73fc-e611-80fa-5065f38ad971",
        country: "us", 
      };

      try {
        const response = await apiPost(POST_PAGE_LOAD_EDIT_CASE, payload);
        dispatch(setLoading(false));

        if (response?.status === 200) {
          const editOptions = JSON.parse(response.data?.editOptions || {});
          const avail = deepParse(response?.data?.CustomerAvailability)
          const hpi_caseextensionid = String(avail?.hpi_caseextensionid)
          const CustomerAvailabilityOption = (response?.data || {})
          setCustomerAvailabilityOptions(CustomerAvailabilityOption)
          setEditCaseDetails(editOptions);
          setAllEmailInteractions(
            JSON.parse(response?.data?.AllEmailInteractions)
          );
          setCaseExtenasionId(hpi_caseextensionid)
          productInfoFetch(editOptions.AssetId, editOptions.PNo);

          const attachedFile = response.data?.AttachedFile
            ? JSON.parse(response.data.AttachedFile)
            : null;

          setAttachedFile(attachedFile);
          fetchData(editOptions, attachedFile,CustomerAvailabilityOption);
        } else {
          handleErrorResponse(response);
        }
      } catch (error: any) {
        dispatch(setLoading(false));
        handleErrorResponse(error);
      }
    };

    const productInfoFetch = (ainfo: any, pno: any) => {
      dispatch(setLoading(true));

      const payload = {
        ainfo: ainfo,
        pno: pno,
        contactid: "85680C15-7814-E711-80FC-5065F38AD971",
      };

      apiPost(POST_PRODUCT_INFO_EDIT_CASE, payload)
        .then((response) => {
          dispatch(setLoading(false));
          const data = response?.data;
          setProductInfo(data);
          setIsActiveCareProduct(data.IsActiveCareProduct);
          setPolyProductInfo(payload)
        })
        .catch((error) => {
          handleErrorResponse(error);
        });
    };

    pageLoadFetch();
  }, [reload]);

  const fetchData = async (editCaseDetails: any, attachedFile: any,CustomerAvailabilityOption: any) => {
    const result = await validateAddress(
      editCaseDetails?.ProductNumberEditPage
    );
    setIsTeradeciCall(result ?? false);
    if (result) {
      setAccordionItems([
        {
          content: <CaseHistory data={editCaseDetails?.CaseHistory || []} />,
          header: {
            centralArea: (
              <h5 className="header-title">
                {t("HPI.EditCase.Case.Casehistory", {
                  defaultValue: "Case History",
                })}
              </h5>
            ),
          },
          id: "accordionItem1of3",
        },
        {
          content: (
            <CaseDetails
              caseDetails={editCaseDetails}
              attachedFilesData={attachedFile}
            />
          ),
          header: {
            centralArea: (
              <h3 className="header-title">
                {t("HPI.EditCase.Casedetails.Casedetails", {
                  defaultValue: "Case Details",
                })}
              </h3>
            ),
          },
          id: "accordionItem3of3",
        },
        {
          content: (
            <CaseEmailInteraction emailInteraction={allEmailInteractions} />
          ),
          expanded: false,
          header: {
            centralArea: <span>Email Interaction</span>,
          },
          id: "accordionItem4of4",
        },
      ]);
    } else {
      setAccordionItems([
        {
          content: <CaseHistory data={editCaseDetails?.CaseHistory || []} />,
          header: {
            centralArea: (
              <h3 className="header-title">
                {t("HPI.EditCase.Case.Casehistory", {
                  defaultValue: "Case History",
                })}
              </h3>
            ),
          },
          id: "accordionItem1of3",
        },
        {
          content: (
            <PartService
              lstPartAndOrder={editCaseDetails?.lstPartAndOrder}
              PartsOrdersEmptyTxt={editCaseDetails?.PartsOrdersEmptyTxt}
              lstServiceOrder={editCaseDetails?.lstServiceOrder}
              OnsiteServiceEmptyTxt={editCaseDetails?.OnsiteServiceEmptyTxt}
            />
          ),
          header: {
            centralArea: (
              <h3 className="header-title">
                {t("HPI.EditCase.Partsandservice.Partsandservice", {
                  defaultValue: "Parts and Service",
                })}
              </h3>
            ),
          },
          id: "accordionItem2of3",
        },
        {
          content: (
            <CaseDetails
              caseDetails={editCaseDetails}
              attachedFilesData={attachedFile}
            />
          ),
          header: {
            centralArea: (
              <h3 className="header-title">
                {t("HPI.EditCase.Casedetails.Casedetails", {
                  defaultValue: "Case Details",
                })}
              </h3>
            ),
          },
          id: "accordionItem3of3",
        },
        {
          content: <LocationInfo locationInfoSummary={editCaseDetails} />,
          expanded: false,
          header: {
            centralArea: (
              <h3 className="header-title">
                {t("HPI.EditCase.contactandequip.contactandequip", {
                  defaultValue: "Contact & Equipment Location Information",
                })}
              </h3>
            ),
          },
          id: "accordionItem4of4",
        },
      ]);
    }
  };

  const changeTabHandler = (id: any) => {
    setActiveAccordian(id);
  };

  useEffect(() => {
    // Set accordion items when editCaseDetails is available


    if (Object.keys(editCaseDetails || {}).length && editCaseDetails?.CaseStatus !== "Closed") {

      console.log(editCaseDetails?.CaseStatus, 'in')
      setAccordionMoreSupportItems([
        {
          content: (
            <MoreSupportOptions
              urlInfo={{
                ainfo: editCaseDetails?.AssetId,
                pno: editCaseDetails?.PNo,
              }}
            />
          ),
          header: { centralArea:  <h3 className="header-title">{t('HPI.EditCase.Case.MoreSupportOption',{defaultValue:'More Support Options'})}</h3> },
          id: "supportOptions",
        },
      ]);
    }
  }, [editCaseDetails]);

  const handleExpand = (event: any, index: any, item: any) => {
    setAccordionItems((prevItems) =>
      prevItems.map((itm, idx) =>
        idx === index ? { ...itm, expanded: true } : itm
      )
    );
  };

  const handleCollapse = (event: any, index: any, item: any) => {
    setAccordionItems((prevItems) =>
      prevItems.map((itm, idx) =>
        idx === index ? { ...itm, expanded: false } : itm
      )
    );
  };

  const cancelCaseHandler = () => {
    setActiveAccordian(5);
  };

  const startChat = () => {
    if (
      editCaseDetails &&
      editCaseDetails.AssetId &&
      editCaseDetails.PNo &&
      editCaseDetails.CaseId &&
      editCaseDetails?.CaseStatus !== "Closed"
    ) {
      let uri = `cid=${searchParams.get("cid") ?? ""}`;
      navigate(`/initiate-chat/?${uri}`);
    } else {
      console.error("editCaseDetails is not fully populated", editCaseDetails);
    }
  };

  useEffect(() => {
    const startChatButton = document.getElementById("2");
    if (startChatButton) {
      startChatButton.addEventListener("click", startChat);
    }
  }, [editCaseDetails, searchParams]);

    const storeTempAttachedFilesHandler = (files:any) => {
      setTempAttachedFilesData(files)
    }

  const submitCaseHandler = (updateText: any) => {
    const data = location.state?.data;
    dispatch(setLoading(true));
    
    const payload = {
      caseId: data?.incidentid || location.state?.incidentid || searchParams.get("cid"),
      txtAreaUpdateCaseNote: updateText,
      //userId: editCaseDetails?.UserId,
    };
    setTempAttachedFilesData([]);
    // Example API call
    apiPost(POST_UPDATE_CASE, payload)
      .then((response) => {
        dispatch(setLoading(false));
        console.log("Case updated successfully:", response);

        if (
          typeof response.data === "object" &&
          "successMessage" in response.data
        ) {
          changeTabHandler(3);
          toast.success(response.data.successMessage);
          setReload(!reload);
        } else {
          handleErrorResponse(response);
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        handleErrorResponse(error);
        // console.error("Error updating case:", error);
      });
  };
  const submitAvailabilityHandler = (payload:any) => {
  const data = location.state?.data;
  dispatch(setLoading(true));

  const normalizedCaseExtensionId =
    caseExtensionId === "undefined" || caseExtensionId === undefined
      ? undefined
      : String(caseExtensionId).trim();

  const request: any = {
    caseId:
      data?.incidentid ??
      location.state?.incidentid ??
      searchParams.get("cid"),
    ContactMethods: payload?.ContactMethods,
    TimeToContact: payload?.TimeToContact,
    CustomerAvailabilityDate: payload?.CustomerAvailabilityDate,
  };
  if (
    normalizedCaseExtensionId &&
    normalizedCaseExtensionId.length > 0
  ) {
    request.caseExtensionId = normalizedCaseExtensionId;
  }

  apiPost(POST_UPDATE_CUSTOMER_AVAILABILITY, request)
    .then(() => {
      dispatch(setLoading(false));
      toast.success("Customer availability updated");
    })
    .catch((err) => {
      dispatch(setLoading(false));
      console.error("API ERROR:", err?.response || err);
      toast.error("Failed to update");
    });
};
  const submitCloseCaseHandler = (updateText: any) => {
    dispatch(setLoading(true));
    const data = location.state?.data; 

    const payload = {
      caseId: data?.incidentid || location.state?.incidentid || searchParams.get("cid"),
      closeTextReasonKey: updateText,
    };

    apiPost(POST_CLOSE_CASE, payload)
      .then((response) => {
        dispatch(setLoading(false));
        console.log("Case Close successfully:", response);
        changeTabHandler(3);
        toast.success(<div dangerouslySetInnerHTML={{__html:t('HPI.EditCase.SuccessClosure',{defaultValue:`<span style='color:green'>Success! Case requested for closure.</span>`})}}></div>);
        setReload(!reload);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        handleErrorResponse(error);
        console.error("Error updating case:", error);
      });
  };

// useEffect(() => {
//   if(localStorage.getItem("isPopup") === "open"){
//     //setShowOnSubmitModal(true);
//   }
// },[]);

const isDisabled = () => {
  if (editCaseDetails?.CaseStatus === "Closed") {
    return true;
  }
};

  return (
    <>
    {/* <FeedBackModal openState = {showFeedbackModal} caseNumberId={caseNumberId}/> */}
    { localStorage.getItem("isPopup") === "open"  ? <OnSubmitModal openState = {showOnSubmitModal} caseNumberId={caseNumberId}/> : "" } 
      <Container fluid className="bg-clr">
        <div className="edit-case">
          <div className="header">
            <h2>{t('HPI.EditCase.Case.EditCase',{defaultValue:'Edit Case'})} {t('HPI.ContractWarranties.ExtendedWarrantyTab.Status',{defaultValue:'Status'})} : {editCaseDetails?.CaseStatus}</h2>
            <p>
              {t('HPI.CreateCase.HPsupportCenter',{defaultValue:'Please provide as much information below to help HP Support Center solve your case.'})}
            </p>
          </div>
          <div>
            <Container className="card-container">
              <Row>
                <CaseItems data={productInfo} polyData = {polyProductInfo} />
              </Row>
            </Container>

            <Container className="p-4" style={{ background: "#f8f8f8" }}>
              <Row>
                <Col className="detail-container">
                  <Tabs
                    controlId="default"
                    mode="contained"
                    onChangeTab={changeTabHandler}
                    selectedTabId={activeAccordian}
                    tabs={[
                      {
                        id: 3,
                        label: t("HPI.EditCase.Case.Caseinformationsummary",{defaultValue:'Case Information Summary'}),
                        content: (
                          <div>
                            {editCaseDetails && (
                              <CaseInformationSummary
                                caseInfoSummary={editCaseDetails}
                                attachedFilesData={attachedFile}
                              />
                            )}
                          </div>
                        ),
                        disabled: isDisabled(),
                      },
                      {
                        id: 0,
                        label: t('HPI.EditCase.Case.UpdateThisCase',{defaultValue:'Update This Case'}),
                        content: (
                          <>
                         
                          <UpdateCase
                            attachedFilesData={attachedFile}
                            cancelCaseHandler={cancelCaseHandler}
                            submitCaseHandler={submitCaseHandler}
                            tempAttachedFilesData={tempAttachedFilesData}
                            storeTempAttachedFilesHandler={storeTempAttachedFilesHandler}
                            />
                          {/* <Card 
                          className="card-contacts p-4"
                          content={<>
                         <EditCustomerAvailability data={customerAvailabilityOptions} 
                            cancelCaseHandler={cancelCaseHandler}
                            submitAvailabilityHandler={submitAvailabilityHandler}  />
                       </>}
                       /> */}
                          </>
                        ),
                        disabled: isDisabled(),
                      },
                      {
                        id: 1,
                        label: t("HPI.EditCase.RequestClose.CloseCase", {
                          defaultValue: "Request to close this case",
                        }),
                        content: (
                          <CloseCase
                            cancelCaseHandler={cancelCaseHandler}
                            submitCaseHandler={submitCloseCaseHandler}
                            caseClsOpts={editCaseDetails?.CaseClsOpts || []}
                          />
                        ),
                        disabled: isDisabled(),
                      },
                      {
                        id: 2,
                        label: t('HPI.EditCase.Case.StartChatThisCase',{defaultValue:'Start Chat for This Case'}),
                        content: <div></div>,
                        disabled: isDisabled(),
                      },
                    ]}
                    type="attached"
                  />
                </Col>
              </Row>
              <div className="m-t-20">
                {isActiveCareProduct ? (
                  <div className="support-more-container">
                    <Accordion
                      behavior="singleExpand"
                      gutter="16px"
                      background="filled"
                      border="outlined"
                      items={accordionMoreSupportItems}
                      onCollapse={handleCollapse}
                      onExpand={handleExpand}
                    />
                  </div>
                ) : null}

                <div className="edit-case-details">
                  <Accordion
                    behavior="singleExpand"
                    gutter="16px"
                    background="filled"
                    border="outlined"
                    items={accordionItems}
                    onCollapse={handleCollapse}
                    onExpand={handleExpand}
                  />
                </div>
              </div>
            </Container>
          </div>
        </div>
      </Container>
    </>
  );
};